<template>
  <v-content style="background-color: #F8F8F8;margin-bottom: 8rem">
    <v-layout class="justify-center my-6">
      <v-flex class="xs11">
        <h2>
          {{ $t("keyword") }} :
          <span style="color: #FD5246;">" {{ $route.query.keyword }} "</span>
        </h2>
      </v-flex>
    </v-layout>

    <div class="mb-12">
      <!-- Article -->
      <v-container fluid class="px-12">
        <v-row>
          <v-col
            v-for="portfolioArticle in portfolio_search.data"
            :key="portfolioArticle.id"
            :cols="
              $vuetify.breakpoint.lgAndUp
                ? 2
                : '' || $vuetify.breakpoint.md
                ? 3
                : '' || $vuetify.breakpoint.sm
                ? 4
                : '' || $vuetify.breakpoint.xs
                ? 12
                : ''
            "
            @click="viewPortDetail(portfolioArticle)"
          >
            <card-content
              font-lg="14"
              :hoverTitle="portfolioArticle.project_title"
              :width="$vuetify.breakpoint.lgAndUp ? '248' : ''"
              height="100%"
              :image-cover="portfolioArticle.cover_img_path"
              :title="portfolioArticle.project_title"
              :by="portfolioArticle.profile"
              :image-profile="
                portfolioArticle.profile
                  ? checkImage(portfolioArticle.profile.mem_info)
                  : ''
              "
            ></card-content>
          </v-col>
        </v-row>
      </v-container>
      <v-layout v-if="portfolio_search.data.length > 0">
        <v-flex class="paginate">
          <v-pagination
            color="#FD5246"
            light
            v-model="portfolio_search.current_page"
            :length="portfolio_search.last_page"
            :total-visible="7"
            @input="onClickSearch"
          ></v-pagination>
        </v-flex>
      </v-layout>

      <v-layout
        class="px-12"
        v-if="portfolio_search.data.length === 0"
        style="padding-bottom: 29rem"
      >
        <v-flex class="text-center">
          <span style="color: #5d5d5d">{{ $t("status-not-fount") }}</span>
        </v-flex>
      </v-layout>
    </div>

    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import CardContent from "../../components/card_content/CardContent";
import { mapState } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Search",
  components: {
    CardContent,
    Loading,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
  }),
  computed: {
    ...mapState({
      portfolio_search: (state) => {
        return state.portfolio.portfolio_search;
      },
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
    }),
  },
  created() {},
  methods: {
    viewPortDetail(port) {
      // let slug =
      //   port.profile.mem_info && port.profile.mem_info.domain_name
      //     ? port.profile.mem_info.domain_name
      //     : port.profile.profile_id;
      // this.$router.push({
      //   path: `/detail-portfolio/${slug}`,
      //   query: { id: port.portfolio_id, pfid: port.profile.profile_id },
      // });
      let domain_slug =
        port.profile.mem_info && port.profile.mem_info.domain_name
          ? port.profile.mem_info.domain_name
          : port.profile.profile_id;
      this.$router.push({
         path: `/profile/${domain_slug}/${port.portfolio_id}`,
      });
    },
    onClickSearch(page) {
      const data = { page: page, keyword: this.$route.query.keyword };
      this.$store.dispatch("portfolio/getPortfolioBySearch", data);
    },
    checkVariable(val) {
      if (val) {
        return val;
      } else {
        return "";
      }
    },
    checkName(val) {
      if (val.profile) {
        if (!val.profile.name_th && !val.profile.last_th) {
          if (val.profile.email.length > 30) {
            return val.profile.email.slice(0, 25) + " . . . . .";
          } else {
            return val.profile.email;
          }
        } else {
          if (val.profile.name_th && val.profile.last_th) {
            if (val.profile.name_th.length > 15) {
              return val.profile.name_th.length > 25
                ? val.profile.name_th.slice(0, 20) + " . . . . "
                : val.profile.name_th;
            } else {
              return (
                (val.profile.name_th.length > 15
                  ? val.profile.name_th.slice(0, 10) + " . . . . "
                  : val.profile.name_th) +
                " " +
                (val.profile.last_th.length > 25
                  ? val.profile.last_th.slice(0, 20) + " . . . . "
                  : val.profile.last_th)
              );
            }
          } else {
            return val.profile.name_th.length > 15
              ? val.profile.name_th.slice(0, 10) + " . . . . "
              : val.profile.name_th;
          }
        }
      } else {
        return "";
      }
    },
    checkImage(val) {
      if (val) {
        if (val.avatar) {
          return val.avatar;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped></style>
